(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/init-kambi-widgets.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/init-kambi-widgets.js');
"use strict";


const {
  ImpleoWidgetDefinition,
  EnetpulseH2hWidgetDefinition,
  EnetpulseTableWidgetDefinition,
  TooltipWidgetDefinition,
  PlaymakerWidgetDefinition,
  TrajectoryWidgetDefinition,
  WalletWidgetDefinition,
  SokWidgetDefinition
} = svs.oddset_kambi.components.kambiWidgetUtils.definitions;
const isMobile = svs.core.detect.formfactor.mobile();
const mediaQuery = isMobile ? window.matchMedia('(max-width: 655px)') : window.matchMedia('(max-width: 669px)');
const initKambiWidgets = () => {
  const widgetDefinitions = [new WalletWidgetDefinition(), new TrajectoryWidgetDefinition(), new ImpleoWidgetDefinition(), new EnetpulseH2hWidgetDefinition(), new EnetpulseTableWidgetDefinition()];
  if (svs.core.detect.feature('ft-kambi-client-playmaker-widget')) {
    widgetDefinitions.push(new PlaymakerWidgetDefinition());
  }
  if (svs.core.detect.feature('ft-kambi-client-sok-widget')) {
    widgetDefinitions.push(new SokWidgetDefinition());
  }
  if (mediaQuery.matches) {
    widgetDefinitions.push(new TooltipWidgetDefinition());
  }
  const widgets = [];
  const targets = {};
  for (const widgetDefinition of widgetDefinitions) {
    widgets.push(widgetDefinition.getDefinition());
    const widgetTargets = widgetDefinition.getTargets();
    for (const targetKey in widgetTargets) {
      if (Array.isArray(targets[targetKey])) {
        targets[targetKey] = [...targets[targetKey], ...widgetTargets[targetKey]];
      } else {
        targets[targetKey] = widgetTargets[targetKey];
      }
    }
  }
  window.widgetSettings = {
    widgets,
    targets,
    sandwichFilterLiveRightNowAboveMenu: {
      coreUxWidgetTop: [{
        widgetId: 'vinter-os-widget'
      }]
    }
  };
};
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.initKambiWidgets', initKambiWidgets);

 })(window);